<template>
  <v-app-bar app color="white" elevation="0" class="teacher-toolbar">
    <button type="button" class="teacher-toolbar__brand" aria-label="Go to home" @click="home">
      <span class="teacher-toolbar__mark" aria-hidden="true">t</span>
      <span class="teacher-toolbar__word">taleem<span>.app</span></span>
    </button>

    <v-app-bar-nav-icon v-if="currentUser && currentUser.userType !== 'teacher'" @click.stop="drawerToggle" />
    <v-spacer />

    <div class="teacher-toolbar__profile" v-if="currentUser">
      <div class="teacher-toolbar__profile-copy">
        <strong>{{ firstName }}</strong>
        <span>Teacher</span>
      </div>
      <UserMenu />
    </div>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserMenu from "./Menu";

export default {
  components: { UserMenu },
  computed: {
    ...mapGetters("global", ["currentBusiness", "currentUser"]),
    firstName() {
      if (!this.currentUser || !this.currentUser.name) return "Teacher";
      return this.currentUser.name.trim().split(" ")[0];
    },
  },
  methods: {
    ...mapActions("teacherLayout", ["drawerToggle"]),
    home() {
      if (this.$route.name !== "home") this.$router.push({ path: "/" });
    },
  },
};
</script>
